import cuisineRenov from "../assets/photos/cuisine-renov.jpg";
import cuisineSquart from "../assets/photos/cuisine-squart.JPG";
import dressingPhoto from "../assets/photos/dressing.jpg";
import parquetSol from "../assets/photos/parquet-sol.jpg";
import salleDeBain from "../assets/photos/Salle-de-bain.jpg";
import cuisineBlancheAngle from "../assets/photos/cuisine-blanche-angle.jpg";
import amenagementExterieur from "../assets/photos/amenagement-exterieur-garde-corps.jpg";

export const projectsData = [
  {
    id: 1,
    title: "Agencement intérieur",
    date: "Mai 2020",
    description: ["Agencement, création et pose de mobilier sur mesure"],
    infos:
      "Réalisation d’un aménagement de magasin minimaliste : rayonnages laqués blancs intégrés sur deux murs, éclairage LED encastré, sol en carrelage gris clair. Un espace épuré conçu pour une mise en valeur optimale des produits.",
    img: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819839/DSC_0955_k2tdt5.jpg",
    link: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819839/DSC_0955_k2tdt5.jpg",
  },
  {
    id: 2,
    title: "Agencement intérieur",
    date: "Octobre 2023",
    description: ["Création de cloison et faux plafond"],
    infos:
      "Travaux d’aménagement intérieur avec pose de faux plafond suspendu, structure métallique pour cloison, et intégration d’éléments techniques (ventilation, éclairage). Chantier en cours avec installation modulaire en cours de finition.",
    img: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819837/DSC_0898_ln9ojg.jpg",
    link: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819837/DSC_0898_ln9ojg.jpg",
  },
  {
    id: 3,
    title: "Aménagement intérieur – faux‑plafond et cloison",
    date: "Mars 2024",
    description: [
      "Pose d’ossature métallique pour faux‑plafond",
      "Préparation cloison intérieure",
    ],
    infos:
      "Réalisation d’un aménagement intérieur avec création d’un faux‑plafond suspendu sur ossature métallique, intégration d’un module de ventilation encastrée, et préparation des cloisons modulaires pour finition haut de gamme.",
    img: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819840/faut-plafond_x2jnvi.jpg",
    link: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819840/faut-plafond_x2jnvi.jpg",
  },
  {
    id: 4,
    title: "Aménagement intérieur – cloison et faux‑plafond",
    date: "Octobre 2023",
    description: ["Cloison modulaire et faux‑plafond sur mesure"],
    infos:
      "Réalisation d’un espace intérieur en cours d’aménagement : pose d’un faux‑plafond décoratif, installation de l’unité de ventilation encastrée, ossature métallique pour cloison amovible. Site préparé pour finition haut de gamme.",
    img: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819838/DSC_0907_ihnxxe.jpg",
    link: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819838/DSC_0907_ihnxxe.jpg",
  },

  {
    id: 5,
    title: "Agencement intérieur – magasin prêt à meubler",
    date: "Décembre 2023",
    description: ["Agencement et rayonnages sur mesure en boutique"],
    infos:
      "Aménagement d’un espace commercial avec sol en carrelage gris clair, murs clairs équipés de rayonnages intégrés, plafond lumineux avec éclairage LED encastré — conçu pour accueillir du mobilier haut de gamme.",
    img: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819839/DSC_0953_siwopz.jpg",
    link: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819839/DSC_0953_siwopz.jpg",
  },
  {
    id: 6,
    title: "Agencement intérieur",
    date: "Juin 2023",
    description: [
      "Agencement complet sur mesure",
      "Finitions menuiserie intérieure",
    ],
    infos:
      "Réaménagement intérieur espace commercial avec mobilier sur mesure, éclairage LED indirect et ambiance haut de gamme.",
    img: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819838/DSC_0936_sqycqb.jpg",
    link: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819838/DSC_0936_sqycqb.jpg",
  },
  {
    id: 7, // (ou l’id que tu souhaites lui donner)
    title: "Agencement intérieur – finition haute gamme",
    date: "Décembre 2023", // ajuste si besoin
    description: [
      "Installation de mobilier sur mesure",
      "Finitions laquées et éclairage intégré",
    ],
    infos:
      "Aménagement complet d’un espace intérieur avec mobilier sur mesure laqué blanc satin, éclairage LED intégré et sol design en carrelage gris clair — esprit épuré et premium.",
    img: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819838/DSC_0940_y1bidc.jpg",
    link: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819838/DSC_0940_y1bidc.jpg",
  },
  {
    id: 8, // adapter selon ta numérotation
    title: "Aménagement intérieur",
    date: "Août 2023", // à ajuster selon la vraie date
    description: ["Création espace sur mesure", "Finitions haut de gamme"],
    infos:
      "Aménagement d’un espace commercial comprenant mobilier sur mesure, finitions laquées blanc satinée, sol en carrelage gris clair et éclairage LED encastré — design épuré et fonctionnel",
    img: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819831/20180716_123747_mlxmzq.jpg",
    link: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819831/20180716_123747_mlxmzq.jpg",
  },
  {
    id: 9, // adapte l’id si besoin
    title: "Aménagement cuisine sur mesure",
    date: "Août 2023", // à adapter si la date réelle est différente
    description: [
      "Réalisation sur mesure",
      "Pose et finition haut gamme",
    ],
    infos: "Réalisation d’une cuisine  sur mesure, finitions laquées.",
    img: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819830/20180817_165527_q1u2co.jpg",
    link: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819830/20180817_165527_q1u2co.jpg",
  },
  {
    id: 10, // à adapter selon ta numérotation
    title: "Cuisine laquée blanc satinée",
    date: "Août 2023", // à ajuster si besoin
    description: [
      "Conception cuisine sur mesure",
      "Finitions laquées blanc satin",
    ],
    infos:
      "Réalisation d’une cuisine sur mesure avec façades laquées blanc satin, plan de travail intégré et éclairage LED discret — design épuré et fonctionnel pour un espace de vie moderne.",
    img: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819832/cuisine_laquer_yexzyx.jpg",
    link: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819832/cuisine_laquer_yexzyx.jpg",
  },
  {
    id: 11,
    title: "Aménagement intérieur – mobilier sur mesure",
    date: "Octobre 2020",
    description: [
      "Création et installation de mobilier sur mesure",
      "Finitions haut de gamme",
    ],
    infos:
      "Conception d’un espace intérieur avec mobilier sur mesure et finitions haut de gamme — ambiance moderne et épurée.",
    img: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819831/20201001_105753_urme8m.jpg",
    link: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819831/20201001_105753_urme8m.jpg",
  },
  {
    id: 12,
    title: "Cuisine studio sur mesure",
    date: "Juillet 2023", // à adapter si besoin
    description: ["Conception cuisine intégrée pour studio"],
    infos:
      "Aménagement d’une cuisine sur mesure dans un studio : façades laquées blanc satin, plan de travail compact, intégration d’électroménager et design épuré adapté à un espace réduit.",
    img: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819838/DSC_0918_fjzoou.jpg",
    link: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819838/DSC_0918_fjzoou.jpg",
  },
  {
    id: 13,
    title: "Mur TV sur mesure – salon contemporain",
    date: "Avril 2023",
    description: ["Mobilier mural laqué blanc", "Agencement TV et rangements"],
    infos:
      "Conception d’un mur TV sur mesure : base en laque blanche satinée, caissons modulaires suspendus, étagères en verre et fond mural contrasté. Intégration élégante d’un espace home-cinéma dans un salon au design épuré.",
    img: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819835/DSC_0769_p0n0jk.jpg",
    link: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819835/DSC_0769_p0n0jk.jpg",
  },
  {
    id: 14, // adapte selon ta numérotation
    title: "Comptoir bar et cuisine sur mesure",
    date: "Mars 2024", // ajuste à la vraie date du projet
    description: [
      "Création de comptoir bar",
      "Aménagement d’espace cuisine et bar",
    ],
    infos:
      "Conception d’un îlot bar/cuisine sur mesure avec base laquée blanc, plan de travail noir épais, tabourets design blancs et agencement soigné.",
    img: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819834/DSC_0767_n54g3o.jpg",
    link: "https://res.cloudinary.com/dl3ntuzaz/image/upload/v1763819834/DSC_0767_n54g3o.jpg",
  },
  {
    id: 15,
    title: "Cuisine renovee sur mesure",
    date: "Projet recent",
    description: ["Pose de cuisine", "Agencement et finitions"],
    infos:
      "Cuisine renovee avec implantation fonctionnelle, rangements optimises, plan de travail et finitions propres pour un espace compact.",
    img: cuisineRenov,
    link: cuisineRenov,
  },
  {
    id: 16,
    title: "Cuisine en angle",
    date: "Projet recent",
    description: ["Cuisine sur mesure", "Optimisation d'espace"],
    infos:
      "Amenagement d'une cuisine en angle avec mobilier integre, surfaces faciles d'entretien et circulation optimisee.",
    img: cuisineSquart,
    link: cuisineSquart,
  },
  {
    id: 20,
    title: "Cuisine blanche en angle",
    date: "Juillet 2026",
    description: ["Cuisine sur mesure", "Pose et finitions"],
    infos:
      "Réalisation d'une cuisine blanche en angle avec rangements intégrés, plan de travail effet marbre et équipements noirs pour un ensemble sobre et fonctionnel.",
    img: cuisineBlancheAngle,
    link: cuisineBlancheAngle,
  },
  {
    id: 17,
    title: "Dressing sur mesure",
    date: "Projet recent",
    description: ["Rangements", "Menuiserie interieure"],
    infos:
      "Creation d'un dressing sur mesure avec rangements adaptes, volumes optimises et finitions sobres.",
    img: dressingPhoto,
    link: dressingPhoto,
  },
  {
    id: 18,
    title: "Renovation de sol",
    date: "Projet recent",
    description: ["Parquet", "Second oeuvre"],
    infos:
      "Renovation de sol avec pose soignee et finition propre pour moderniser l'espace interieur.",
    img: parquetSol,
    link: parquetSol,
  },
  {
    id: 21,
    title: "Aménagement extérieur et garde-corps",
    date: "Mai 2026",
    description: ["Sécurisation des accès", "Pose de garde-corps métalliques"],
    infos:
      "Aménagement des accès extérieurs avec installation de garde-corps métalliques autour de la descente de garage et le long du passage latéral.",
    img: amenagementExterieur,
    link: amenagementExterieur,
  },
  {
    id: 19,
    title: "Salle de bain renovee",
    date: "Projet recent",
    description: ["Salle de bain", "Renovation interieure"],
    infos:
      "Renovation de salle de bain avec travail de second oeuvre, finitions nettes et agencement pratique.",
    img: salleDeBain,
    link: salleDeBain,
  },
];
